import {DAMAGE_DICE_MIN_VALUE} from "../../configs/damage";

// Штраф к ГРАНИ кости урона: фора новичкам — отряды ботов и нейтральные
// отряды бросают против такого игрока хуже (см. configs/lowRatingAdvantage).
// Грань уменьшается на штраф, но ниже худшей грани кости (-3) не опускается:
// честная -3 так и остается -3. Итог — всегда существующая грань кости, поэтому
// в состоянии, в записи матча и на экране она ничем не отличается от обычной.
// Штраф отрицательным не бывает: улучшать грань этот путь не должен
export const applyDamageDiceFacePenalty = (face, facePenalty = 0) => {
  const safeFacePenalty = Math.max(0, facePenalty || 0);
  if (safeFacePenalty === 0) {
    return face;
  }

  return Math.max(DAMAGE_DICE_MIN_VALUE, face - safeFacePenalty);
};
